// Certificate fingerprints generated on 2025-06-13T22:44:29.364Z
const PINNED_CERTIFICATES = {
  'api.routescan.io': [
    'sha256/yprO3RdpOIxoDOVyoAN+v1ibx0wGncDMEJAUmY3E4Sc=',
  ],
  'explorer.bit-rock.io': [
    'sha256/CREVlP+/IQPBn8lem+vBLcE18UcEYyVDfqeLdzjZhYU=',
  ],
  'api.imgbb.com': [
    'sha256/QAA/Laf2XA3si2zGpuY9mUKRNoPTTipSzGaF+X0/vtw=',
  ],
  'api.sushi.com': [
    'sha256/QSPmvz70NTNXmB4sHThtjlWf6RWSTvV7lxDAyEqQxDc=',
  ],
  'api.coingecko.com': [
    'sha256/yepWCg9cR1DNbDI3Z00H2rwkwgDxU2dz11ejif7EPwg=',
  ],
  'deep-index.moralis.io': [
    'sha256/dFsBI5A1qhNntExqWSnf6peX4FrNhOeTQ6fRyKR48wY=',
  ],
  'tara.to': [
    'sha256/dyKO8DMlguZxWcrb6lp3AI7NGEc2yuL5RvbIh9CJErI=',
  ],
  'omaxscan.com': [
    'sha256/PNgwKS6qVVcLaCxZMZ20Uaf7MNincVm44LI1BmgXKdw=',
  ],
  'explorer.infinaeon.com': [
    'sha256/hWjMCTrgr3EI+jdx/Zyu1pcHmt/4sO+csHYWhpdE7Qg=',
  ],
  'etherscan.io': [
    'sha256/aOLV6huNCmhP3UVBNr9BtU1aU5ORbophhPL+90raxyA=',
  ],
  '1rpc.io': [
    'sha256/E15o95tDD4T0Y4U3wFI5RNU74GwuNRfg4rRtY3GgiYo=',
  ],
  'polygon-rpc.com': [
    'sha256/5CN/gKSlxfPTPItknD2BJmTihQ2Cqafo1ATkSMXw2IA=',
  ],
  'api.geckoterminal.com': [
    'sha256/LElpZcFgLQrXR9j7q/UsYa1uQhZAme49MQ1wP1MvNlA=',
  ],
  'api.duckduckgo.com': [
    'sha256/goTOgt4HK77vCJgOugiuxgYdd5tvpdPg98i0+/1vwkE=',
  ],
  'raw.githubusercontent.com': [
    'sha256/fREi6paYUjQejdkrzAx+zACWMNFNpzTXykLVtUorIJc=',
  ],
  'api.fomo.biz': [
    'sha256/IHEfH56M3OfIP7DRv57GW7B0zM4gUFSiIOCEj81+uwY=',
  ],
  '0xrpc.io': [
    'sha256/KlHbh66EDot/nk2JXSrZBDsR6jOHLzFi+A+WUGN4wic=',
  ],
  'connect.bit-rock.io': [
    'sha256/OCoIk+ooxiyCjG7W+nPnObHz3IXM2BZDEUai5Xnh/ik=',
  ],
  'rpc.infinaeon.com': [
    'sha256/hWjMCTrgr3EI+jdx/Zyu1pcHmt/4sO+csHYWhpdE7Qg=',
  ],
  'mainapi.omaxray.com': [
    'sha256/jP95YjXgRiZIt2v/WnVM6AAG3o6GPqgKSh06bAUk7aQ=',
  ],
  'rpc.mainnet.taraxa.io': [
    'sha256/M7WzOe9UZqI+wgEej6sKAemmHXr7UNHlsRF6PWdQc8w=',
  ],
  'bit-dog.com': [
    'sha256/vbUXSK7b2mnN7qDFkTBDgkMY6qx5ysa/KyPFcFkE3Eo=',
  ],
  'arb1.arbitrum.io': [
    'sha256/kB2W/c7/J4Y7Zc8ZJ87TP3kLSJbAKQNxKNuWjhfUDLc=',
  ],
};

export default PINNED_CERTIFICATES;